export default "__VITE_ASSET__B1q8Pjgl__"